export default __webpack_public_path__ + "static/media/Icon_live.c7c97ba6.svg";